import React from 'react';

import { ExternalLink } from './ExternalLink';

import { Section } from './Section';
import { UL } from './UL';
import { LI } from './LI';

export const LE1_2 = () => (
  <Section gapBefore>

    <UL>
      <LI>
        Diskutieren Sie anschließend die Ergebnisse im Klassenverband: Warum sind Marken wichtig? Wie oft im Jahr muss ein neuer Trend mitgemacht werden? Warum wird Secondhand abgelehnt?
      </LI>

      <LI gapBefore>
        Alternative Analyse der Meinungsbilder: Lassen Sie Ihre SuS den folgenden Typen-Test machen:
        <br />
        <ExternalLink href="https://www.bpb.de/lernen/formate/275636/test-wie-bist-du-drauf" />
        <br />
        und besprechen Sie im Klassenverband die Ergebnisse (auf verallgemeinerter Ebene): Wie wichtig ist den SuS Mode und welche Ziele
        verfolgen sie mit ihrem Style? Sie können diese Themen auch anhand vorhandener Aussagen von verschiedenen Jugendlichen besprechen:
        <br />
        <ExternalLink href="https://www.bpb.de/lernen/formate/142180/modekonsum" />
      </LI>

      <LI gapBefore>
        Kleider machen Leute? Lassen Sie die verschiedenen Personen auf den Fotos von den SuS beschreiben und reflektieren Sie anschließend,
        wie viel von der <b>Personen-Beschreibung</b> auf die Kleidung bezogen ist und ob das zutreffend sein muss.
      </LI>
    </UL>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE1_2.js